import { render, staticRenderFns } from "./confirmMoveBrokenLinkModal.vue?vue&type=template&id=2c5b7394&"
import script from "./confirmMoveBrokenLinkModal.vue?vue&type=script&lang=js&"
export * from "./confirmMoveBrokenLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports